import {NullAsDefault} from "views/Shared/typedefs";
import React from 'react'

export const LayoutContext = React.createContext({
  width: 600,
  breakpoint: 'sm',
  breakpoints: {},
  leftSideBarWidth: 'var(--leftSideBar-width)',
  rightSideBarWidth: 'var(--leftSideBar-width)',
  smallLayout: false,
  LeftLayout: NullAsDefault,
  RightLayout: NullAsDefault,
  stickyOffset: 'var(--sticky-offset)',
  visibleLeftDrawer: false,
  setVisibleLeftDrawer: NullAsDefault,
  visibleRightDrawer: false,
  setVisibleRightDrawer: NullAsDefault,
  openMenu: false,
  setOpenMenu: NullAsDefault,
})
